export const flashMessages = {
  home: {
    error: {
      cannotFetchNews:
        'Une erreur est survenue pendant le chargement des informations.'
    }
  },
  downloadLink: {
    error: {
      cannotFetchData: `Les données n'ont pas pu être téléchargées depuis le serveur.`
    }
  },
  contact: {
    error: {
      cannotSend: `Une erreur est survenue pendant l'envoi de votre message. Veuillez essayer de nous joindre par un autre moyen.`
    },
    success: {
      successSend: `Votre message a bien été transmis à notre équipe, nous vous remercions de l'intérêt que vous nous portez.`
    }
  },
  newsletter: {
    success: {
      successfullyAdd:
        'Votre adresse mail a été ajoutée à notre mailing list avec succès.'
    },
    error: {
      cannotAdd:
        'Cette adresse mail est déjà enregistrée pour recevoir notre newsletter'
    }
  },
  tool: {
    error: {
      cannotSend:
        'There has been an error submitting you tool. Please fill all the mandatory fields'
    },
    success: {
      successSend:
        'Thank you ! The tool has been successfully submitted. It is now awaiting validation by the OECD Secretariat.'
    }
  }
}
